// src/pages/volunteering/api/forms.js
import API_ENDPOINTS from "../../../services/apiEndpoints";
import { getAuthToken } from "../../../auth/auth";

export const getTemplates = async () => {
  const token = await getAuthToken();

  const res = await fetch(`${API_ENDPOINTS.VOLUNTEERING_FORMS}/forms/templates`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!res.ok) {
    throw new Error("Failed to fetch templates");
  }

  return res.json();
};
// Create a new form
export const createForm = async (formData) => {
  const token = await getAuthToken();
  const res = await fetch(`${API_ENDPOINTS.VOLUNTEERING_FORMS}/forms`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(formData)
  });

  if (!res.ok) {
    throw new Error("Failed to create form");
  }

  return await res.json();
};

// Get all forms
export const getAllForms = async () => {
  const token = await getAuthToken();
  const res = await fetch(`${API_ENDPOINTS.VOLUNTEERING_FORMS}/forms/list`, {
    headers: { Authorization: `Bearer ${token}` }
  });

  if (!res.ok) {
    throw new Error("Failed to fetch forms");
  }

  return await res.json();
};

// Get single form by ID
export const getFormById = async (formId) => {
  const token = await getAuthToken();
  const res = await fetch(`${API_ENDPOINTS.VOLUNTEERING_FORMS}/forms/${formId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });

  if (!res.ok) {
    throw new Error("Failed to fetch form");
  }

  return await res.json();
};

// Update a form
export const updateForm = async (formData) => {
  const token = await getAuthToken();
  const res = await fetch(`${API_ENDPOINTS.VOLUNTEERING_FORMS}/forms`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(formData)
  });

  if (!res.ok) {
    throw new Error("Failed to update form");
  }

  return await res.json();
};

// Delete a form
export const deleteForm = async (formId) => {
  const token = await getAuthToken();
  const res = await fetch(`${API_ENDPOINTS.VOLUNTEERING_FORMS}/forms/${formId}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` }
  });

  if (!res.ok) {
    throw new Error("Failed to delete form");
  }

  return await res.json();
};

// Submit form (Public - No auth)
export const submitForm = async (formId, formData) => {
  const res = await fetch(`${API_ENDPOINTS.VOLUNTEERING_FORMS}/forms/${formId}/submit`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData)
  });

  if (!res.ok) {
    throw new Error("Failed to submit form");
  }

  return await res.json();
};

// Get form submissions (Admin)
export const getFormSubmissions = async (formId) => {
  const token = await getAuthToken();

  const res = await fetch(`${API_ENDPOINTS.VOLUNTEERING_FORMS}/forms/${formId}/submissions`, {
    headers: { Authorization: `Bearer ${token}` }
  });

  if (!res.ok) {
    throw new Error("Failed to fetch submissions");
  }

  return await res.json();
};

// Download CSV (Admin)
export const downloadSubmissionsCSV = async (formId) => {
  const token = await getAuthToken();

  const res = await fetch(`${API_ENDPOINTS.VOLUNTEERING_FORMS}/forms/${formId}/submissions/csv`, {
    headers: { Authorization: `Bearer ${token}` }
  });

  if (!res.ok) {
    throw new Error("Failed to download CSV");
  }

  return res; // Return response to handle blob
};
